import { render, staticRenderFns } from "./TrainingDetails.vue?vue&type=template&id=1bdca898&scoped=true&"
import script from "./TrainingDetails.vue?vue&type=script&lang=ts&"
export * from "./TrainingDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingDetails.vue?vue&type=style&index=0&id=1bdca898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdca898",
  null
  
)

export default component.exports